const fromStoreToStoreResult = (storeData)=>{
    const { code , globalStoreId , name , shortName , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , distance , wheelchairAccessible , hearingAppointmentPossible , isFranchise ,  } = storeData;
    return {
        code,
        globalStoreId,
        name,
        shortName,
        streetName,
        town,
        country,
        phone,
        streetNumber,
        additionalStreetInfo,
        postalCode,
        province,
        lat,
        lon,
        distance,
        emailAddress: undefined,
        appointmentTypes: [],
        servicesNotAvailable: [],
        openingHours: {
            monday: [],
            tuesday: [],
            wednesday: [],
            thursday: [],
            friday: [],
            saturday: [],
            sunday: []
        },
        wheelchairAccessible,
        hearingAppointmentPossible,
        specialOpeningHours: [],
        isFranchiseStore: isFranchise
    };
};

export { fromStoreToStoreResult };
//# sourceMappingURL=from-store-to-store-result.js.map
